export const getSessionParam = (paramName: string): string | null =>
    sessionStorage.getItem(paramName);

export const saveSessionParameters = (name: string, value: string): void => {
    sessionStorage.setItem(name, value);
};

export const clearSessionParameters = (): void => {
    sessionStorage.clear();
};

export const saveLocalParameter = (name: string, value: string): void => {
    localStorage.setItem(name, value);
};

export const removeLocalParameter = (name: string): void => {
    localStorage.removeItem(name);
};

export const getLocalParam = (paramName: string): string | null =>
    localStorage.getItem(paramName);
